// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"bbc33695","453":"ad9cfa50","682":"05a1c24d","747":"0ac638e0","889":"f6cc6352","962":"6dcc73be"}[chunkId] + ".chunk.js";
};